export class CollectionDetailRequest {
  public userName: string;
  public collectionId: number;
}